import React from "react";
import { Link } from "react-router-dom";
import styles from "../../../styles/styles";

const Hero = () => {
  return (
    <>
      <section className="main-hero-area">
        <div className="container">
          <div className="banner-content">
            {/* <div className="content">
              <p>
                <h3>
                  <span>Ways of food</span>
                </h3>
                order ready made and cooked food from your local outlets and
                restaurants and supermarkets. order, subscribe and eat.
              </p>
              <span className="rate-reviews">
                <span>⭐️⭐️⭐️⭐️⭐️</span> 4.4 (6000+ Reviews)
              </span>
              <h3>
                Order<span> Home-Cooked</span>
              </h3>
              <h2>
                Food from Local <span>Chefs!</span>
              </h2>
              <p>
                Eat authentic, homemade food & support small family businesses
                in your neighborhood!
              </p>
            </div> */}
            <div className="content space-y-4">
              {/* Eyebrow / Tagline */}
              <div>
                <h3 className="text-lg font-semibold tracking-wide uppercase text-green-500">
                  <span className=" text-green-800 px-3 py-1 rounded-full">
                    Ways of Food
                  </span>
                </h3>
                <p className="text-gray-600 mt-2 max-w-prose">
                  Order ready-made and cooked food from your local outlets,
                  restaurants, and supermarkets. Order, subscribe, and eat.
                </p>
              </div>

              {/* Rating */}
              <div className="flex items-center gap-2 text-sm text-gray-500 justify-center sm:justify-start">
                <span className="text-yellow-400 text-lg">⭐️⭐️⭐️⭐️⭐️</span>
                <span>4.4 (6000+ Reviews)</span>
              </div>

              {/* Main Headings */}
              <h3 className="text-xl font-bold text-gray-800">
                Order <span className="text-green-500">Home-Cooked</span>
              </h3>
              <h2 className="text-4xl font-extrabold text-gray-900 leading-tight">
                Food from Local <span className="text-green-500">Chefs!</span>
              </h2>

              {/* Supporting Text */}
              <p className="text-gray-600 max-w-prose">
                Eat authentic, homemade food & support small family businesses
                in your neighborhood!
              </p>
            </div>

            <div className="seacrh-form">
              <form>
                <div className="form-group">
                  <input placeholder="Search by Meal or Location" />
                  <Link to="/products" className="btn primary-btn">
                    Find Food
                  </Link>
                </div>
              </form>
            </div>
            <div className="cta-wrap">
              <a href="#" className="btn danger-btn">
                Become a Chef
              </a>
              <a href="#" className="btn btn-nobg">
                <span>
                  <img
                    src="https://wof-v3.devservertd.com/wof-img/play-i.svg"
                    alt=""
                  />
                </span>{" "}
                Watch Video
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
